import { CATEGORY } from '@/constants/cookie-registry'
import { DEFAULT_LOCALE } from '@/constants/languages'
import { alpha2, readCountry } from './country'
import { uuid4 } from './uuid'

function isoWithOffset(date) {
  const pad = (value) => String(Math.floor(Math.abs(value))).padStart(2, '0')
  const offsetMinutes = -date.getTimezoneOffset()
  const sign = offsetMinutes >= 0 ? '+' : '-'

  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    sign +
    pad(offsetMinutes / 60) +
    ':' +
    pad(Math.abs(offsetMinutes) % 60)
  )
}

// The two versions are passed in rather than read here, so that the caller stamps the cookie
// with exactly the values it puts in the body. Reading them twice would let a revision published
// between the two reads leave the journal and the cookie disagreeing about what was agreed to.
export function buildDecision({
  action,
  categories,
  source,
  consentId,
  country,
  reConsentReason,
  bannerVersion,
  cookieListVersion,
}) {
  const now = new Date()

  const body = {
    action,
    analytics: Boolean(categories[CATEGORY.ANALYTICS]),
    marketing: Boolean(categories[CATEGORY.MARKETING]),
    source,
    banner_version: bannerVersion,
    cookie_list_version: cookieListVersion,
    locale: localStorage.getItem('app_locale') || DEFAULT_LOCALE,
    client_recorded_at: isoWithOffset(now),
    // Raw getTimezoneOffset(): minutes UTC is ahead of local time, so Kyiv in summer is -180.
    // The sign is inverted from the ISO offset above on purpose - that is what the API
    // documents, and flipping it here would put the wrong zone in the journal.
    tz_offset: now.getTimezoneOffset(),
  }

  if (consentId) {
    body.consent_id = consentId
  }

  // Optional in the contract, and validated as exactly two characters - so it is sent only
  // when it really is a country code. See ./country.js for why nothing is substituted.
  const code = alpha2(country) || readCountry()
  if (code) {
    body.country = code
  }

  // Why the banner came back, kept apart from which button was pressed. It is part of what the
  // journal compares between retries, so it is written once here and never recomputed.
  if (reConsentReason) {
    body.re_consent_reason = reConsentReason
  }

  return {
    key: uuid4(),
    body,
  }
}
